// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tilasto[data-v-9c4e622e] {\n  height: 100vh;\n}\n.height-100-minus-ylaosa[data-v-9c4e622e] {\n  height: calc(100% - 224px);\n}\n.height-100[data-v-9c4e622e] {\n  height: 100%;\n}\nfm-pivot > div[data-v-9c4e622e] {\n  height: 100%;\n}", ""]);
// Exports
module.exports = exports;
